import { z } from 'zod';
import { packagingQuantizationSchema, packagingRuntimeSchema, packagingStatusSchema, } from '../enums.js';
/**
 * Packaging de modèle pour le déploiement edge (ADR-0034). Un **paquet** relie un modèle validé
 * (`Model`, statut `READY`) à une **cible matérielle** (`HardwareAsset`) et fige les choix de
 * packaging : `runtime`, `quantization`, `inputSize`. Cloisonné par organisation. Le binaire produit
 * (`.engine`, `.tflite`, `.onnx`) est un objet MinIO servi par URL pré-signée — il ne traverse pas
 * l'API (CLAUDE.md §2).
 */
/**
 * Création d'un paquet (brouillon). La cible est **facultative** : on peut figer les choix de
 * packaging sans matériel désigné. `runtime`/`quantization` sont les choix retenus — la
 * recommandation dérivée (`derivePackagingRecommendation`) n'est qu'un conseil surchargeable.
 */
export const createModelPackageSchema = z.object({
    modelId: z.string(),
    targetAssetId: z.string().nullable().optional(),
    runtime: packagingRuntimeSchema,
    quantization: packagingQuantizationSchema,
    inputSize: z.number().int().min(64).max(2048).default(640),
});
/** Paquet tel que restitué par l'API. `modelName`/`targetAssetName` sont joints pour l'affichage. */
export const modelPackageSchema = z.object({
    id: z.string(),
    modelId: z.string(),
    modelName: z.string(),
    modelVersion: z.string(),
    targetAssetId: z.string().nullable(),
    targetAssetName: z.string().nullable(),
    runtime: packagingRuntimeSchema,
    quantization: packagingQuantizationSchema,
    inputSize: z.number().int().positive(),
    status: packagingStatusSchema,
    error: z.string().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
//# sourceMappingURL=packaging.js.map